import angular from 'angular';
import _ from 'lodash';
import contactChannelsIconsComponent from './contactChannelsIconsComponent.html';
import {
    CONTACT_CHANNEL_LABELS,
    isChannelContactConfirmed,
    checkIsEmptyChannel,
    getFormattedContactChannelDate,
    getChannelIcon,
    sortChannelContactItemsByDate,
    isEmployerContactCandidate,
} from './contactChannelsIconsUtils';
import './style.scss';
import { CONTACT_CHANNEL_TYPES } from '../recruiter/constants/contactTypes';

export class ContactChannelsIconsController {
    contactChannels = {};

    /* @ngInject */
    constructor($filter) {
        this.$filter = $filter;
    }

    getTooltipMessage(channel) {
        const t = this.$filter('translate');

        return (channel.contactDataItems || []).map((channelContactDataItem) => {
            const isResponseItem = !!_.get(channelContactDataItem, 'confirmedDate');

            const tooltipMessageText = isResponseItem ? 'CONFIRMED_RESPONSE' : 'CONTACTED_VIA_CHANNEL';
            const eventDate = _.get(channelContactDataItem, 'confirmedDate') || _.get(channelContactDataItem, 'contactedDate');
            const formattedDate = getFormattedContactChannelDate(eventDate);
            const messageItem = t(tooltipMessageText, { date: formattedDate, channel: t(CONTACT_CHANNEL_LABELS[channel.name]) });
            const senderDetails = _.get(channelContactDataItem, 'contactedByInfo.name', '');

            if (isResponseItem) {
                return messageItem;
            }

            return senderDetails ? `${messageItem} ${senderDetails}` : messageItem;
        }).join('<br />\n');
    }

    $onChanges() {
        this.isEmployerContactCandidate = isEmployerContactCandidate(this.contactChannels);
        this.channels = [
            CONTACT_CHANNEL_TYPES.EMAIL,
            CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE,
            CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL,
            CONTACT_CHANNEL_TYPES.FACEBOOK,
            CONTACT_CHANNEL_TYPES.TALK,
        ].map(channelName => ({
            contactDataItems: sortChannelContactItemsByDate(_.get(this.contactChannels, `channelData.${channelName}`, {})),
            name: channelName,
        })).reduce((result, currentChannel) => {
            if (checkIsEmptyChannel(currentChannel)) {
                return result;
            }

            const isConfirmed = isChannelContactConfirmed(currentChannel);

            const contactItemsCount = _.chain(currentChannel)
                .get('contactDataItems')
                .map('contactedDate')
                .filter(Boolean)
                .size()
                .value();

            result.push({
                tooltipMessage: this.getTooltipMessage(currentChannel),
                count: contactItemsCount,
                icon: getChannelIcon(currentChannel.name, isConfirmed),
            });

            return result;
        }, []);
    }
}

export const ContactChannelsIconsConfiguration = {
    template: contactChannelsIconsComponent,
    bindings: {
        contactChannels: '<',
    },
    controller: ContactChannelsIconsController,
    controllerAs: 'contactChannelsCtrl',
};

angular
    .module('TALENYA-FE')
    .component('contactChannelsIcons', ContactChannelsIconsConfiguration);
